import {GetMaterialTypes, CreateMaterialType} from "../../api/MaterialTypeApi";
import {GetSubjects, CreateSubject} from "../../api/SubjectApi";
import {MaterialTypeInputs} from "../MaterialType/MaterialTypeInputs";
import {SubjectInputs} from "../Subject/SubjectInputs";

export const MaterialInputs = [
  { name: 'name', label: "Name", type: 'text', defaultValue: '', validation: { required: "Please enter a title" } },
  { name: 'materialType', label: 'Material Type', getItems: GetMaterialTypes, optionValue: 'name',
    validation: { required: "Select valid option", validate: val => val.name ? true : 'Please choose a material type' },
    type: 'autocomplete',
    defaultValue: { name: '' },
    inputs: MaterialTypeInputs,
    addNew: CreateMaterialType
  },
  { name: 'subjects', label: 'Subjects', getItems: GetSubjects, optionValue: 'name',
    type: 'autocomplete',
    multiple: true,
    defaultValue: [],
    inputs: SubjectInputs,
    addNew: CreateSubject
  }
];